/**
 * Guest Fragment
 * Handles guest account list select-all functionality
 */

import { Events } from '../../../../js/utils/events.js';

let initialized = false;

// ============================================================================
// Guest Handlers
// ============================================================================

const GuestHandlers = {
    /**
     * Handle select-all checkbox change
     * Toggles all guest checkboxes in the list
     */
    onSelectAll(e, element) {
        const container = element.closest('#guest-account-list');
        if (!container) return;

        const checkboxes = container.querySelectorAll('[data-guest-checkbox]');
        checkboxes.forEach(cb => {
            cb.checked = element.checked;
        });
    },

    /**
     * Handle individual guest checkbox change
     * Updates select-all state based on individual checkboxes
     */
    onRowCheckboxChange(e, element) {
        const container = element.closest('#guest-account-list');
        if (!container) return;

        GuestHandlers.updateSelectAllState(container);
    },

    /**
     * Update select-all checkbox state based on individual checkboxes
     */
    updateSelectAllState(container) {
        const selectAll = container.querySelector('#select-all');
        const checkboxes = container.querySelectorAll('[data-guest-checkbox]');

        if (!selectAll || checkboxes.length === 0) return;

        const checkedCount = container.querySelectorAll('[data-guest-checkbox]:checked').length;

        if (checkedCount === 0) {
            selectAll.checked = false;
            selectAll.indeterminate = false;
        } else if (checkedCount === checkboxes.length) {
            selectAll.checked = true;
            selectAll.indeterminate = false;
        } else {
            selectAll.checked = false;
            selectAll.indeterminate = true;
        }
    }
};

// ============================================================================
// Initialization
// ============================================================================

export function initGuest() {
    if (initialized) return;
    initialized = true;

    // Select-all checkbox
    Events.on('change', 'guest-select-all', GuestHandlers.onSelectAll);

    // Individual guest checkbox (for updating select-all state)
    Events.on('change', 'guest-checkbox', GuestHandlers.onRowCheckboxChange);

    console.log('[LeapFILE] Guest fragment initialized');
}
